import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import { PaginationInfo } from "../../models/loan.model";

import { Button, Grid, SelectChangeEvent } from "@mui/material";
import {
  NATIONAL,
  SUPPLIER_ATTACHMENTS_UPLOADED,
  TABLE_FILTER,
  TABLE_FILTER_CUSTOMER_ROWNumber,
} from "../../config/cacheKey";
import { GetStatusResponse } from "../../models/basicInformation.model";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import createCache from "@emotion/cache";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { createTheme } from "@mui/material/styles";
import { useState } from "react";
import useCollapse from "react-collapsed";
import { useHistory, withRouter } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
// import { Pagination } from "@mui/material";
import { createStyles, makeStyles } from "@material-ui/core";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Formik } from "formik";
import { connect, useDispatch, useSelector } from "react-redux";
import ChipCmp from "../../components/chip/chipCmp";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  Filter,
  GetAppRegistrationItemsResponse,
  GetSupplierSettlementItemsRequest,
} from "../../models/cartable.model";
import { GetRegistrationItems } from "../../services/cartable.service";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "assigner", label: "ارجاع دهنده" },
  { id: "customerFullName", label: "متقاضی" },
  { id: "nationalCode", label: "کد ملی" },
  {
    id: "mobileNumber",
    label: "شماره موبایل",
  },
  // {
  //   id: "requestDatePersian",
  //   label: "تاریخ ثبت",
  // },
  // {
  //   id: "loanTemplateTitle",
  //   label: "طرح ",
  // },

  // {
  //   id: "loanRequestSourceTitle",
  //   label: "منبع درخواست",
  // },
  {
    id: "organizationTitle",
    label: "سازمان",
  },
  { id: "loanTemplateTitle", label: "نام طرح" },
  {
    id: "financialSupplierTitle",
    label: " تامین کننده مالی ",
  },
  {
    id: "amount",
    label: "مبلغ  (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  // {
  //   id: "profitRate",
  //   label: "سود ",
  //   hasFormat: true,
  //   format: (vlaue: number) => {
  //     return `%${vlaue}`;
  //   },
  // },

  // {
  //   id: "bankApproveDatePersian",
  //   label: "تاریخ تغییر وضعیت ",
  // },
  // {
  //   id: "settlementDatePersian",
  //   label: "تاریخ تغییر وضعیت تسویه",
  // },
  // {
  //   id: "supplierUserTitle",
  //   label: "ثبت کننده ",
  // },
];

let muiSelected: any;

function TableRegCmp({ stateCartable, status }: TableCmpPropsInterface) {
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  /*********** filter added */
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();
  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    queryClient.setQueryData<string>(NATIONAL, selectedItem);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerNationalCode = undefined;
    fillData(tabelFilter!);
  };
  function changeValueCustomerNationalCode(e: any) {
    queryClient.setQueryData<string>(NATIONAL, e.currentTarget.value);
    setValueCustomerNationalCode(e.currentTarget.value);
  }
  /*********** filter added */

  let row: any;
  const queryClient = useQueryClient();
  const oldPage = queryClient.getQueryData<Filter>(
    TABLE_FILTER_CUSTOMER_ROWNumber
  );
  const activePage = localStorage.getItem("setActivePage");

  const dispatch = useDispatch();
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
    loanRequestId: number;
    natinalCode: string;
    activeCancleButton: boolean;
  }>();
  const [isExpanded, setExpanded] = useState(false);
  const [valueMultiSelect, setValueMultiSelect] = useState([]);
  const [
    valueSupplierSettlementStatus,
    setValueSupplierSettlementStatus,
  ] = useState([]);
  const [valueLoanRequestSources, setValueLoanRequestSources] = useState([]);
  const [valueLoanTemplateOptions, setValueLoanTemplateOptions] = useState([]);
  const [valueSupplierUserOptions, setValueSupplierUserOptions] = useState([]);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [data, setData] = React.useState<GetAppRegistrationItemsResponse[]>([]);
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const [loanRequestOptions, setLoanRequestOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [
    supplierSettlementOptions,
    setSupplierSettlementOptions,
  ] = React.useState<GetStatusResponse[]>([]);
  const [
    loanRequestSourceOptions,
    setLoanRequestSourceOptions,
  ] = React.useState<GetStatusResponse[]>([]);
  const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [supplierUserOptions, setSupplierUserOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [requestDate, setRequestDate] = React.useState<Date | null | undefined>(
    null
  );

  React.useEffect(() => {
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER_CUSTOMER_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER_CUSTOMER_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }

    const filter = new Filter();
    filter.state = stateCartable.stateCartable;
    let nationalCache = queryClient.getQueryData<string>(NATIONAL);
    // filter.customerNationalCode = '';
    // filter.loanRequestStatus = [];
    // filter.supplierSettlementStatus = [];
    // filter.loanTemplateIds = [];
    // filter.loanRequestSources = [];
    // filter.supplierUserIds = [];
    filter.customerNationalCode = nationalCache;
    if (stateCartable.stateCartable) {
      fillData(filter);
    }
    queryClient.setQueryData(TABLE_FILTER, filter);
    queryClient.setQueryData(TABLE_FILTER_CUSTOMER_ROWNumber, filter);
  }, [stateCartable]);
  React.useEffect(() => {
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        if (
          filterData.customerNationalCode !== undefined &&
          filterData.customerNationalCode !== null
        ) {
          setValueCustomerNationalCode(filterData?.customerNationalCode!);
        }
      }
    } else {
      filterData = new Filter();
      filterData.customerNationalCode = "";
      queryClient.setQueryData(TABLE_FILTER, null);
    }
  }, []);

  const GetRegistrationItemsMutation = useMutation(GetRegistrationItems, {
    onSuccess: (result: ApiResultModel<GetAppRegistrationItemsResponse[]>) => {
      if (result) {
        setData(result.data);
        setPageInfo(result.pageInfo);
      }
    },
  });
  const setChildValueStat = (childValues: any) => {
    const selectedItem = valueMultiSelect.filter(
      (item: any) => item != childValues
    );
    setValueMultiSelect(selectedItem);
  };
  const setChildValueStatSettelment = (childValues: any) => {
    const selectedItem = valueSupplierSettlementStatus.filter(
      (item: any) => item != childValues
    );
    setValueSupplierSettlementStatus(selectedItem);
  };

  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;
  const disposeListener = history.listen((navData) => {
    if (
      navData.pathname.includes("/loan/CustomerRegistration") &&
      history.location.state !== undefined &&
      history.location.state.pageNumber!
    ) {
      currentPaginationInfo.pageNumber = history.location.state.pageNumber;
      setCurrentPaginationInfo(currentPaginationInfo);
    }
  });
  const generateFilter = (
    filterData: Filter
  ): GetSupplierSettlementItemsRequest => {
    let request = new GetSupplierSettlementItemsRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    //checked
    if (request.filter != undefined && request.filter != null) {
      request.filter.state = stateCartable?.stateCartable;
    } else {
      const filter = new Filter();
      filter.state = stateCartable.stateCartable;
      if (stateCartable.stateCartable) {
        request.filter = filter;
      }
    }
    if (
      queryClient.getQueryData("STATECARTABLE_APP") !=
      stateCartable.stateCartable
      //  && oldPage_?.state != undefined
    ) {
      currentPaginationInfo.pageNumber = 1;
      setCurrentPaginationInfo(currentPaginationInfo);
      queryClient.setQueryData(
        "STATECARTABLE_APP",
        stateCartable.stateCartable
      );
    }
    return request;
  };
  React.useEffect(() => {
    if (history.action === "POP") {
      currentPaginationInfo.pageNumber = 1;
      setCurrentPaginationInfo(currentPaginationInfo);
    }
  }, [stateCartable.stateCartable]);
  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetRegistrationItemsMutation.mutate(filter);
  };
  //  React.useEffect(()=>
  //   {fillData(new Filter())},[]
  //  )
  const changePageNumber = (newPageNumber: number) => {
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    // fillData(new Filter())
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    changePageNumber(newPage + 1);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    // handleSelectRow(selectedRow);
    handleSelectRow(undefined);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  const handleChangeMultiselect = (
    event: SelectChangeEvent<typeof loanRequestOptions>
  ) => {
    const {
      target: { value },
    } = event;
    // setLoanRequestOptions(
    //   // On autofill we get a stringified value.
    //    typeof value === GetStatusResponse() ? value.split(',') : value,
    // );
  };
  const handleDetail = (
    referenceKey: string,
    rowIndex: number,
    loanRequestId: number,
    natinalCode: string
  ) => {
    window.sessionStorage.setItem("id", referenceKey);
    window.sessionStorage.setItem("loanRequestId", loanRequestId?.toString());
    window.sessionStorage.setItem("natinalCode", natinalCode);
    handleSelectRow(rowIndex);
    currentPaginationInfo.rowNumber = rowIndex;
    queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
    //history.push(`/loan-detail/${referenceKey}`);
    history.push({
      pathname: `/loan/${activePage}1/loan-detail`,
      state: {
        id: referenceKey,
        from: "",
        pageNumber: currentPaginationInfo.pageNumber!,
        clickOnBack: false,
        loanRequestId: loanRequestId,
        natinalCode: natinalCode,
        activeCancleButton: true,
      },
    });
    localStorage.setItem(
      "activeCancleButton",
      JSON.stringify({ activeCancleButton: true })
    );
  };

  function handelCollapse() {
    setExpanded(!isExpanded);
  }
  function changeMultiSelectChip(e: any) {
    setValueMultiSelect(e);
  }
  function changeValueSupplierSettlementStatus(e: any) {
    setValueSupplierSettlementStatus(e);
  }
  function changeValueLoanRequestSources(e: any) {
    setValueLoanRequestSources(e);
  }
  function changeValueLoanTemplateOptions(e: any) {
    setValueLoanTemplateOptions(e);
  }
  function changeValueSupplierUserOptions(e: any) {
    setValueSupplierUserOptions(e);
  }

  function deleteChip() {
    setValueCustomerNationalCode("");
    queryClient.setQueryData<string>(NATIONAL, "");
    const filter = new Filter();
    filter.state = stateCartable.stateCartable;
    fillData(filter);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
    // queryClient.setQueryData(TABLE_FILTER, null);
  }
  const filter = new Filter();
  filter.state = " []";
  // filter.supplierSettlementStatus = [];
  // filter.loanTemplateIds = [];
  // filter.loanRequestSources = [];
  // filter.supplierUserIds = [];
  const lessFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropUpIcon style={{ color: "#1D4A87" }} />
      فیلترهای کمتر{" "}
    </span>
  );
  const extraFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropDownIcon style={{ color: "#1D4A87" }} />
      فیلترهای بیشتر
    </span>
  );

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };
  const handleSelectRow = (rowIndex: any) => {
    const filter = new Filter();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    // queryClient.setQueryData(TABLE_FILTER, filter);
    queryClient.setQueryData(TABLE_FILTER_CUSTOMER_ROWNumber, filter);
  };
  return (
    <>
      <Formik
        initialValues={filter}
        onSubmit={(values: any) => {
          values.state = stateCartable.stateCartable;
          values.customerNationalCode = valueCustomerNationalCode;
          queryClient.setQueryData(TABLE_FILTER, values);
          fillData(values);
          currentPaginationInfo.pageNumber = 1;
          setCurrentPaginationInfo(currentPaginationInfo);
        }}
      >
        {({ handleSubmit, handleChange, values }) => (
          <form onSubmit={handleSubmit} onChange={handleChange}>
            <div className="row" style={{ paddingBottom: " 5px " }}>
              <div
                className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                style={{ marginTop: "1vh" }}
              >
                <MaterialTextFieldComponent
                  // className="shadowTextField"
                  helperText={""}
                  placeHolder={"کد ملی"}
                  label={"کد ملی "}
                  required={false}
                  value={valueCustomerNationalCode}
                  onChange={changeValueCustomerNationalCode}
                  name="customerNationalCode"
                  id="customerNationalCode"
                />
              </div>
              <div
                className=" col-4  col-lg-2 col-md-3  butFilter"
                style={{ marginTop: "1vh" }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  className="btnForm SuccessDefault  "
                >
                  فیلتر
                </Button>
              </div>
            </div>
            {valueCustomerNationalCode ? (
              <div
                className="row tableCMP"
                style={{ marginBottom: "10px", marginTop: "0" }}
              >
                <Button
                  onClick={deleteChip}
                  style={{
                    justifyContent: "right",
                    minWidth: "25px",
                    marginRight: "-1vh",
                  }}
                >
                  <img
                    style={{ height: "24px", width: "24px" }}
                    src="images/RemoveAllFilters.svg"
                  />
                </Button>

                <ChipCmp
                  item={valueCustomerNationalCode}
                  enamValue={valueCustomerNationalCode}
                  index={valueCustomerNationalCode?.length}
                  setChildValue={setChildValueCustomerNationalCode}
                />
                <br />
              </div>
            ) : null}
          </form>
        )}
      </Formik>
      <div className="cardTableBorder">
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                ></TableCell>
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
                {/* <TableCell className="rowTHead colorTitle" align="right">
                  <span className="colorTitle textFont12 fontWeight">
                    وضعیت
                  </span>
                </TableCell> */}
                <TableCell className="rowTHead colorTitle" align="right">
                  <span className="colorTitle textFont12 fontWeight">
                    وضعیت ثبت نام
                  </span>
                </TableCell>
                {/* <TableCell className="rowTHead colorTitle" align="right">
                  <MoreHorizIcon
                    scale="scale(1.8) "
                    style={{ color: "#1D4A87" }}
                  />
                  
                </TableCell> */}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data
                ? data.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.entityId}
                        selected={selectedRow === rowIndex}
                        onClick={() =>
                          handleDetail(
                            row.referenceKey,
                            rowIndex,
                            row.id,
                            row.nationalCode
                          )
                        }
                      >
                        <TableCell className="textFont12" align="right">
                          {row.isInUserCartable ? (
                            <EmojiObjectsIcon
                              style={{ color: "#fbc02d", fontSize: "25px" }}
                            />
                          ) : (
                            <EmojiObjectsOutlinedIcon
                              style={{ color: "#C1C7CB", fontSize: "25px" }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          className="textFont12"
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[
                              column.id as keyof GetAppRegistrationItemsResponse
                            ];
                          return (
                            <TableCell
                              className="textFont12"
                              key={column.id}
                              align="right"
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value?.toString()}
                            </TableCell>
                          );
                        })}
                        {/* <TableCell className="textFont12" align="right">
                      <span
                        className={
                          "badge " +
                          (row.loanRequestStatusColor
                            ? row.loanRequestStatusColor === "GreenLable"
                              ? "badge-success"
                              : "badge-danger"
                            : "badge-light")
                        }
                      >
                        {row.loanRequestStatusTitle}
                      </span>
                    </TableCell> */}

                        <TableCell className="textFont12" align="right">
                          <span
                          // className={
                          //   "badge " +
                          //   (row.supplierSettlementStatusColor
                          //     ? row.supplierSettlementStatusColor ===
                          //       "GreenLable"
                          //       ? "badge-success"
                          //       : "badge-danger"
                          //     : "badge-light")
                          // }
                          >
                            {row.loanRequestStatusTitle}
                          </span>
                        </TableCell>
                        {/* <TableCell>
                      <MoreHorizIcon
                        scale="scale(1.8) "
                        className="cursorPointer"
                        style={{ color: "#1D4A87" }}
                        onClick={() => handleDetail(row.referenceKey)}
                      />
                    </TableCell> */}
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <div className="row"></div>
        <Grid container xs={12}>
          <Grid item xs={4}>
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo?.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={4}>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                display: "flex",
                justifyContent: "center !important",
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
                //  button.sele
              }}
              count={
                pageInfo ? Math.ceil(pageInfo?.total / pageInfo?.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </div>
    </>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(connect(mapStateToProps)(TableRegCmp));
const onKeyDown = (e: any) => {
  e.preventDefault();
};
